<template>
  <NuxtLayout name="sticky">
    <template #header>
      <ResultsHeader />
    </template>

    <LcCard :body-class="showResultsTierTable ? 'p-100 pb-200' : 'p-none'" header-class="p-100">
      <template #header>
        <div class="results-header flex flex-col p-100 pb-200 gap-200 rounded-m">
          <ResultsWinningNumbers />
          <ResultsWinningCombinations />
          <ResultsDateTime />
        </div>
      </template>

      <ResultsTierTable v-if="showResultsTierTable" />
    </LcCard>

    <LcInfoText class="pt-300 px-100 pb-200" size="small" :text="$t('results.disclaimer')" />
  </NuxtLayout>
</template>

<script lang="ts" setup>
definePageMeta({
  layout: false,
  scrollToTop: false,
  tracking: { name: 'ResultDetail' },
})

const { isEvaluated, prizeTierCategories, showWithAddOn } = await useResultDetails()

const showResultsTierTable = computed(
  () => isEvaluated.value && prizeTierCategories.value?.length > 0,
)

onUnmounted(() => {
  showWithAddOn.value = false
})
</script>

<style lang="scss" scoped>
.results-header {
  background-color: token('color/background/secondary/secondary');
}
</style>
